import React, {
    useRef, useState,
    // useEffect 
} from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../mensajes2';
import { Dimmer } from '../spinner';

import useTable from '../useTable';
// import { validaSoloNumero } from '../../util/varios';
// import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import axios from 'axios';
// import hex_md5 from '../../util/Md5';

const ValidarUsuario = props => {
    /*  variables de estados */
    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const [activate, setActivate] = useState(false);
    const txtPass = useRef();
    const txtLogin = useRef();
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [pass, setPass] = useState('');
    const [mask, setMask] = useState('*');
    const verificarClave = () => {
        let endpoint = `${op.conexion}/api/comun/clavesupervisor`;
        setActivate(true);
        let nomclave = '';
        switch (props.llamado) {
            case 0:
                nomclave = 'clavesuperadmin';
                break;
            case 1:
                nomclave = 'clavesuperteso';
                break;
            case 2:
                nomclave = 'clavesuperpresu';
                break;
            case 3:
                nomclave = 'clavesuperconta';
                break;
            case 4:
                nomclave = 'clavesuperhacienda';
                break;
            case 5:
                nomclave = 'clavesupercat';
                break;
        }
        let body = {
            login: txtLogin.current.value.trim(),
            //pass: txtPass.current.value.trim(),
            pass: pass.trim(),
            nomclave: nomclave
        }
        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            setActivate(false);
            if (response.status == 200) {
                setActivo(true);
                setPass('');
                props.onHideConfirmar()
            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });
    }
    const seleccionarUsuario = (login) => {
        let campos = 'login, idusuario, clavesuperpresu';
        let nomtab = 'usuario';
        let nomid = 'login';
        let nomid2 = 'superpresu';
        let id2 = true;
        let endpoint = op.conexion + `/api/consulta/modeli2?campos=${campos}&id=${login}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${id2}`;
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status == 200) {
                if (response.data.length !== 0) {
                    setActivo(false);
                    txtPass.current.focus();
                } else {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No Existe Usuario Registrado', icono: 'informacion' });
                    setActivo(true)
                    txtPass.current.value = ''
                }
            }
            setActivate(false);
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }
    const blanquear = () => {
        setActivo(true);
        setActivate(false);
        setPass('');
    }
    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }
    const validarUsuario = (event) => {
        event.preventDefault();
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarUsuario(event.target.value);
            } else {
            }
        }
    }
    const onChangeValidar = (e) => {
        e.preventDefault();
        let sigue = true;
        if (txtPass.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No Existe Usuario Registrado', icono: 'informacion' });
            sigue = false;
            txtPass.current.focus()
        }
        if (sigue) {
            verificarClave()
        }
    }
    const handleInputClave = (event) => {
        event.preventDefault();
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                btnAcepta.current.focus();
            } else {
            }
        }
    }

    const updatePass = (e) => {
        let newValue = e.target.value
        let newLength = newValue.length / mask.length
        let oldLength = pass.length * mask.length
        if (pass.length < newLength) {
            setPass(pass + newValue.slice(oldLength));
        }
        if (pass.length > newLength) {
            setPass(pass.slice(0, newLength));
        }
    }

    const cerrarMensaje = () => {
        let msg = mensaje.texto;
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        if (msg === 'LA CONTRESEÑA ES INCORRECTA') {
            setTimeout(() => {
                txtPass.current.focus();
            }, 100);
        }
    }
    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{
                backgroundColor: 'rgba(0, 0, 0, 0.521)'
            }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                txtLogin.current.focus();
            }}
        >
            <Modal.Header className='azulGradiant px-4 py-2'>
                <Modal.Title className='text-light fs-4 fw-bold m-0'>Log-In.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={cerrarMensaje} />
                <Dimmer active={activate} inverted>

                </Dimmer>

                <div className='col-12 mx-auto px-0 row'>

                    <div class="input-group input-group-sm mb-2 col-md-12 mx-auto">
                        <span class="input-group-text">Usuario:</span>
                        <input type="text" class="form-control" ref={txtLogin} autocomplete="off" onKeyUp={validarUsuario} onBlur={validarUsuario} />
                    </div>

                    <div class="input-group input-group-sm mb-2 col-md-12 mx-auto">
                        <span class="input-group-text ">Clave:</span>
                        <input type="text" value={mask.repeat(pass.length)} onChange={updatePass} ref={txtPass} autocomplete="off" disabled={activo} class="form-control bg-light" onKeyUp={handleInputClave} />
                    </div>


                </div>

            </Modal.Body>
            <Modal.Footer>
                <div className='col-12 m-0 p-0 d-flex justify-content-center gap-2'>
                    <button ref={btnAcepta}
                        className="col-5 btn btn-primary btn-sm rounded"
                        disabled={activo}
                        onClick={onChangeValidar}>
                        <i className="fas fa-check-circle"> Aceptar</i>
                    </button>
                    <button ref={btnCancela}
                        onClick={cancelar}
                        className="btn bg-light btn-sm rounded col-5">
                        <i className="fa"> Cancelar</i>
                    </button>
                </div>

            </Modal.Footer>
        </Modal>
    );
}

export default ValidarUsuario;